<template>
  <div>
    <el-row>
      <el-col>

        <el-form :inline="true" :model="formInline" ref="formInline" class="user-search" size="small"
          label-width="100px">
          <el-form-item label="企业名称：" prop="carNo">
            <el-input size="small" v-model="formInline.goodName" placeholder="请输入企业名称" style="width: 200px"
              @keyup.enter.native="init()">
            </el-input>
          </el-form-item>

          <el-form-item label="" prop="carNo">
            <el-checkbox v-model="formInline.cancel" true-label="1" false-label="0">包含已作废</el-checkbox>
          </el-form-item>

          <el-form-item style="margin-left: 20px;">
            <el-button size="small" type="primary" algin="left" @click="init()">搜索</el-button>
            <el-button size="small" type="reset" algin="left" @click="reset()">重置</el-button>
            <el-button size="small" type="primary" algin="left" @click="add()">新增</el-button>
          </el-form-item>
        </el-form>


        <el-table size="small" :data="eveyData" highlight-current-row v-loading="loading" border stripe
          element-loading-text="拼命加载中" style="width: 100%" ref="multipleTable" height="600px">

          <el-table-column align="center" prop="企业名称" label="企业名称" min-width="200" fixed>
            <template slot-scope="scope">
              <span>
                {{ scope.row.企业名称 != null ? scope.row.企业名称 : "--" }}
              </span>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="企业账号" label="企业账号" fixed>
            <template slot-scope="scope">
              <span class="overHidden">
                {{ scope.row.企业编号 != null ? scope.row.企业编号 : "--" }}
              </span>
            </template>
          </el-table-column>

          <el-table-column align="center" prop="账号类型" label="账号类型" fixed>
            <template slot-scope="scope">
              <span class="overHidden">
                {{ scope.row.账号类型 != null ? scope.row.账号类型 : "--" }}
              </span>
            </template>
          </el-table-column>

          <el-table-column align="center" prop="企业云ID" label="企业云ID" show-overflow-tooltip fixed>
            <template slot-scope="scope">
              <span class="overHidden" style="font-weight: 900;color: #409EFF;">
                {{ scope.row.企业云ID != null ? scope.row.企业云ID : "--" }}
              </span>
            </template>
          </el-table-column>

          <el-table-column align="center" prop="企业密码" label="企业密码" fixed>
            <template slot-scope="scope">
              <span class="overHidden">
                {{ scope.row.企业密码 != null ? scope.row.企业密码 : "--" }}
              </span>
            </template>
          </el-table-column>


          <el-table-column align="center" prop="过期时间" label="账号过期时间" min-width="110" fixed>
            <template slot-scope="scope">
              <span class="overHidden">
                {{ scope.row.过期时间 != null ? scope.row.过期时间 : "--" }}
              </span>
            </template>
          </el-table-column>

          <el-table-column align="center" prop="标志" label="标志" min-width="50">
            <template slot-scope="scope">
              <span class="overHidden">
                {{ scope.row.标志 == 1 ? '--' : "无效" }}
              </span>
            </template>
          </el-table-column>

          <el-table-column align="center" prop="磅站数量" label="磅站数量" min-width="80">
            <template slot-scope="scope">
              <span class="overHidden">
                {{ scope.row.磅站数量 != '' ? scope.row.磅站数量 : "--" }}
              </span>
            </template>
          </el-table-column>

          <el-table-column align="center" prop="启用二维码过磅" label="启用二维码过磅" min-width="120">
            <template slot-scope="scope">
              <span class="overHidden">
                {{ scope.row.启用二维码过磅 == 'True' ? '启用' : '--' }}
              </span>
            </template>
          </el-table-column>


          <el-table-column align="center" prop="启用预约过磅" label="启用预约过磅" min-width="110">
            <template slot-scope="scope">
              <span class="overHidden">
                {{ scope.row.启用预约过磅 == 'True' ? '启用' : '--' }}
              </span>
            </template>
          </el-table-column>


          <el-table-column align="center" prop="启用预约审核" label="启用预约审核" min-width="110">
            <template slot-scope="scope">
              <span class="overHidden">
                {{ scope.row.启用预约审核 == 'True' ? '启用' : '--' }}
              </span>
            </template>
          </el-table-column>



          <el-table-column align="center" prop="管理基础信息" label="管理基础信息" min-width="120">
            <template slot-scope="scope">
              <span class="overHidden">
                {{ scope.row.管理基础信息 == '1' ? '启用' : '--' }}
              </span>
            </template>
          </el-table-column>

          <el-table-column align="center" prop="管理远程充值" label="管理远程充值" min-width="110">
            <template slot-scope="scope">
              <span class="overHidden">
                {{ scope.row.管理远程充值 == '1' ? '启用' : '--' }}
              </span>
            </template>
          </el-table-column>

          <el-table-column align="center" prop="管理称重数据" label="管理称重数据" min-width="110">
            <template slot-scope="scope">
              <span class="overHidden">
                {{ scope.row.管理称重数据 == '1' ? '启用' : '--' }}
              </span>
            </template>
          </el-table-column>

          <el-table-column align="center" prop="集团管理" label="多站点管理" min-width="90">
            <template slot-scope="scope">
              <span class="overHidden">
                {{ scope.row.集团管理 == '1' ? '启用' : '--' }}
              </span>
            </template>
          </el-table-column>

          <el-table-column align="center" prop="小程序预约自定义" label="小程序预约" min-width="90">
            <template slot-scope="scope">
              <span class="overHidden">
                {{ scope.row.小程序预约自定义 == '1' ? '启用' : '--' }}
              </span>
            </template>
          </el-table-column>

          <el-table-column align="center" prop="错误次数" label="错误次数" min-width="80">
            <template slot-scope="scope">
              <span class="overHidden">
                {{ scope.row.错误登录次数 != '' ? scope.row.错误登录次数 : '--' }}
              </span>
            </template>
          </el-table-column>

          <el-table-column align="center" prop="上次登录IP" label="上次登录IP" min-width="120">
            <template slot-scope="scope">
              <span class="overHidden">
                {{ scope.row.上次登录IP != '' ? scope.row.上次登录IP : '--' }}
              </span>
            </template>
          </el-table-column>

          <el-table-column align="center" prop="编辑" label="编辑" min-width="50">
            <template slot-scope="scope">
              <span class="overHidden">
                <el-button size="mini" type="primary" algin="left" @click="editItem(scope.row)">编辑</el-button>
              </span>
            </template>
          </el-table-column>


          <el-table-column align="center" prop="小程序推送启用名称" label="小程序推送" min-width="120">
            <template slot-scope="scope">
              <span class="overHidden">
                {{ scope.row.小程序推送启用名称 != '' ? scope.row.小程序推送启用名称 : '--' }}
              </span>
            </template>
          </el-table-column>

          <el-table-column align="center" label="小程序管理" min-width="120">
            <template slot-scope="scope">
              <div style="display: inline-block;margin:0 5px">
                <el-button type="success" size="mini" @click="openPush(scope.row)"> {{ scope.row.小程序推送启用标志 == 1 ?
                  '禁用' : '启用' }}
                </el-button>

              </div>
            </template>
          </el-table-column>

          <el-table-column align="center" prop="司机实时输入功能" label="司机实时输入功能" min-width="140">
            <template slot-scope="scope">
              <span class="overHidden">
                {{ scope.row.司机实时输入功能 != '' ? scope.row.司机实时输入功能 : "--" }}
              </span>
            </template>
          </el-table-column>

          <el-table-column align="center" prop="实时输入有效期" label="实时输入有效期" min-width="130">
            <template slot-scope="scope">
              <span class="overHidden">
                {{ scope.row.实时输入有效期 != '' ? scope.row.实时输入有效期 : "--" }}
              </span>
            </template>
          </el-table-column>


          <el-table-column label="实时输入管理" align="center" min-width="200px">
            <template slot-scope="scope">

              <!-- <div style="display:inline-block">
                <el-button size="mini" @click="handleEdit(scope.$index, scope.row)"><i class="el-icon-edit"></i>
                </el-button>
              </div> -->

              <div style="display: inline-block;margin:0 5px">
                <el-button type="success" size="mini" @click="realTimeInput(scope.row)"> {{ scope.row.司机实时输入标志 == 1 ?
                  '编辑' : '开启' }}
                </el-button>

                <el-button v-show="scope.row.司机实时输入标志 == 1" type="danger" size="mini" @click="handleStop(scope.row)">
                  关闭
                </el-button>
              </div>


            </template>
          </el-table-column>

          <el-table-column align="center" prop="启用云盒名称" label="启用云盒" min-width="100">
            <template slot-scope="scope">
              <span class="overHidden">
                {{ scope.row.启用云盒名称 != null ? scope.row.启用云盒名称 : "--" }}
              </span>
            </template>
          </el-table-column>



          <el-table-column align="center" prop="云盒类型名称" label="云盒类型" min-width="100">
            <template slot-scope="scope">
              <span class="overHidden">
                {{ scope.row.云盒类型名称 != '' ? scope.row.云盒类型名称 : "--" }}
              </span>
            </template>
          </el-table-column>


          <el-table-column align="center" prop="云盒车号识别仪名称" label="云盒车号识别仪" min-width="130">
            <template slot-scope="scope">
              <span class="overHidden">
                {{ scope.row.云盒车号识别仪名称 != '' ? scope.row.云盒车号识别仪名称 : "--" }}
              </span>
            </template>
          </el-table-column>


          <el-table-column align="center" prop="云盒有效期" label="云盒有效期" min-width="100">
            <template slot-scope="scope">
              <span class="overHidden">
                {{ scope.row.云盒有效期 != '' ? scope.row.云盒有效期 : "--" }}
              </span>
            </template>
          </el-table-column>


          <el-table-column label="云盒管理" align="center" min-width="200px">
            <template slot-scope="scope">

              <div style="display: inline-block;margin:0 5px">

                <el-button type="success" size="mini" @click="startCloudBox(scope.row)"> {{ scope.row.启用云盒 != '0' ?
                  '编辑' : '开启' }}
                </el-button>


                <el-button type="success" size="mini" @click="equipmentManagement(scope.row)"> 设备管理 </el-button>


                <el-button v-show="scope.row.启用云盒 != '0'" type="danger" size="mini" @click="StopCloudBox(scope.row)">
                  关闭
                </el-button>
              </div>
            </template>
          </el-table-column>



          <!-- <el-table-column align="center" prop="权限" label="权限">
            <template slot-scope="scope">
              <span class="overHidden">
                {{ scope.row.权限 != null ? scope.row.权限 : "--" }}
              </span>
            </template>
          </el-table-column>


          <el-table-column align="center" prop="是管理员" label="是管理员">
            <template slot-scope="scope">
              <span class="overHidden">
                {{ scope.row.是管理员 == 'True' ? '是' : "否" }}
              </span>
            </template>
          </el-table-column>

          <el-table-column align="center" prop="空间大小" label="空间大小">
            <template slot-scope="scope">
              <span class="overHidden">
                {{ scope.row.空间大小 != '' ? scope.row.空间大小 : "--" }}
              </span>
            </template>
          </el-table-column>

          <el-table-column align="center" prop="用户数量" label="用户数量">
            <template slot-scope="scope">
              <span class="overHidden">
                {{ scope.row.用户数量 != null ? scope.row.用户数量 : "--" }}
              </span>
            </template>
          </el-table-column> -->

          <!-- <el-table-column align="center" prop="启用二维码过磅" label="启用二维码过磅" min-width="130">
            <template slot-scope="scope">
              <span class="overHidden">
                {{ scope.row.启用二维码过磅 == 'True' ? '启用' : "停用" }}
              </span>
            </template>
          </el-table-column>

          <el-table-column align="center" prop="启用预约过磅" label="启用预约过磅" min-width="110">
            <template slot-scope="scope">
              <span class="overHidden">
                {{ scope.row.启用预约过磅 == 'True' ? '启用' : "停用" }}
              </span>
            </template>
          </el-table-column>

          <el-table-column align="center" prop="启用预约审核" label="启用预约审核" min-width="110">
            <template slot-scope="scope">
              <span class="overHidden">
                {{ scope.row.启用预约审核 == 'True' ? '启用' : "停用" }}
              </span>
            </template>
          </el-table-column> -->

          <!-- <el-table-column align="center" prop="错误登录次数" label="错误登录次数" min-width="110">
            <template slot-scope="scope">
              <span class="overHidden">
                {{ scope.row.错误登录次数 != '' ? scope.row.错误登录次数 : "--" }}
              </span>
            </template>
          </el-table-column>

          <el-table-column align="center" prop="上次登录IP" label="上次登录IP" min-width="100">
            <template slot-scope="scope">
              <span class="overHidden">
                {{ scope.row.上次登录IP != null ? scope.row.上次登录IP : "--" }}
              </span>
            </template>
          </el-table-column>

          <el-table-column align="center" prop="上次登录时间" label="上次登录时间" min-width="150">
            <template slot-scope="scope">
              <span class="overHidden">
                {{ scope.row.上次登录时间 != null ? scope.row.上次登录时间 : "--" }}
              </span>
            </template>
          </el-table-column>

          <el-table-column align="center" prop="操作员" label="操作员">
            <template slot-scope="scope">
              <span class="overHidden">
                {{ scope.row.操作员 != null ? scope.row.操作员 : "--" }}
              </span>
            </template>
          </el-table-column>

          <el-table-column align="center" prop="操作日期" label="操作日期" min-width="150">
            <template slot-scope="scope">
              <span class="overHidden">
                {{ scope.row.操作日期 != null ? scope.row.操作日期 : "--" }}
              </span>
            </template>
          </el-table-column> -->

        </el-table>




        <!-- 弹框内容******************************************************************************************************************************************** -->

        <!-- 实时输入弹框 -->
        <el-dialog title="实时输入" :visible.sync="dialogVisible" width="40%" :before-close="handleClose">
          <div style="margin: 20px 0;padding-left: 10px;">
            司机实时输入功能:{{ isOpen }}
          </div>

          <div style="margin: 20px 0;">
            <label for="" style="margin-left:10px;">磅站数量:</label>

            <el-select ref="typeRef" v-model="bzNum" placeholder="磅站数量" style="width: 250px">
              <el-option v-for="item in bzList" :key="item.id" :label="item.label" :value="item.value">
              </el-option>
            </el-select>


            <label for="" style="margin-left:10px;">有效期:</label>
            <el-date-picker size="small" v-model="time" type="date" placeholder="选择日期" format="yyyy-MM-dd"
              value-format="yyyy-MM-dd">
            </el-date-picker>
          </div>

          <span slot="footer" class="dialog-footer">
            <el-button size="small" @click="dialogVisible = false">取 消</el-button>
            <el-button size="small" type="primary" @click="saveSS">确 定</el-button>
          </span>
        </el-dialog>





        <!-- 云盒管理弹框 -->
        <el-dialog title="云盒管理" :visible.sync="dialogVisible2" width="40%" :before-close="handleClose2">
          <div style="margin: 20px 0;padding-left: 10px;">
            云盒管理功能:{{ isOpen2 }}
          </div>

          <div style="margin: 20px 0;">
            <label for="" style="margin-left:10px;">磅站数量:</label>

            <el-select ref="typeRef" v-model="bzNum2" placeholder="磅站数量" style="width: 250px" size="small">
              <el-option v-for="item in bzList" :key="item.id" :label="item.label" :value="item.value">
              </el-option>
            </el-select>

            <div style="height: 50px;line-height: 50px;">
              <label for="" style="margin-left:10px;">云盒类型:</label>
              <el-radio-group v-model="boxType">
                <el-radio :label="1">PC云盒</el-radio>
                <el-radio :label="2">PLC云盒</el-radio>
              </el-radio-group>
            </div>


            <div style="height: 50px;line-height: 50px;">
              <label for="" style="margin-left:10px;">云盒车号识别仪:</label>
              <el-radio-group v-model="boxCar">
                <el-radio :label="0">不启用</el-radio>
                <el-radio :label="1">启用</el-radio>
              </el-radio-group>
            </div>


            <label for="" style="margin-left:10px;">有效期:</label>
            <el-date-picker size="small" v-model="time2" type="date" placeholder="选择日期" format="yyyy-MM-dd"
              value-format="yyyy-MM-dd">
            </el-date-picker>
          </div>

          <span slot="footer" class="dialog-footer">
            <el-button size="small" @click="dialogVisible2 = false">取 消</el-button>
            <el-button size="small" type="primary" @click="saveSCB">确 定</el-button>
          </span>
        </el-dialog>



        <!-- 设备管理 -->
        <el-dialog title="设备管理" :visible.sync="dialogVisible3" width="40%" :before-close="handleClose3">

          <div style="margin: 20px 0;">

            <div class="boxLeft">
              <el-form ref="ruleForm" label-width="100px">

                <h2>{{ displayText }}</h2>

                <!-- PC  -->
                <el-form-item :label="'磅站' + item.地磅ID" class="hadAddBtn" v-for="(item, index) in PCBoxList"
                  :key="index" v-show="isPC">
                  <el-input type="text" v-model="item.设备ID" size="small" style="width: 200px;"></el-input>

                  <el-button type="primary" @click="PCSave(index)" size="small">保存</el-button>

                </el-form-item>


                <!-- PLC  -->

                <el-form-item :label="'磅站' + item.地磅ID" class="hadAddBtn" v-for="(item, index) in PLCBoxList"
                  :key="index" v-show="isPLC">
                  <el-input type="text" v-model="item.设备ID" size="small" style="width: 200px;"></el-input>

                  <el-button type="primary" @click="PLCSave(index)" size="small">保存</el-button>
                </el-form-item>

              </el-form>

            </div>

            <div class="boxRight" v-show="isCarNo">

              <el-form ref="ruleForm" label-width="100px">

                <h2>车号识别仪列表</h2>

                <el-form-item :label="'车号识别仪' + item.地磅ID" class="hadAddBtn" v-for="(item, index) in videoBoxList"
                  :key="index">
                  <el-input type="text" v-model="item.相机UID" size="small"></el-input>
                </el-form-item>

              </el-form>

            </div>

          </div>

          <span slot="footer" class="dialog-footer">
            <el-button size="small" @click="dialogVisible3 = false">取 消</el-button>
            <el-button size="small" type="primary" @click="saveSSS">确 定</el-button>
          </span>
        </el-dialog>

        <!-- 弹框内容******************************************************************************************************************************************** -->

        <!-- 新增用户  -->
        <addCustomers ref="addCustomersDialog" @reset="reset"></addCustomers>

        <!-- 编辑用户 -->
        <editCustomers ref="editCustomersDialog" @reset="reset"></editCustomers>


      </el-col>
    </el-row>
  </div>
</template>
<script>
import { customerList, start, stop, SCloudBox, ECloudBox, PCList, PLCList, getVideoBoxList, PCUpdate, PLCUpdate } from "../../api/userMG";
import addCustomers from "./addCustomers.vue";
import editCustomers from "./editCustomers.vue";
export default {
  // 注册组件
  components: {
    addCustomers,
    editCustomers,
  },

  data() {
    return {
      formInline: {
        goodName: "",
        cancel: "0",
      },
      dialogVisible: false,
      dialogVisible2: false,
      dialogVisible3: false,
      time: "",
      time2: "",
      eveyData: [], //index返回的数组
      loading: false,
      isOpen: "",
      isOpen2: "",
      ID: "",
      ID2: "",
      bzList: [],
      bzNum: "1",
      bzNum2: "1",
      itemRow: [],
      // 单选组
      boxType: 1,
      boxCar: 0,

      // 列表组
      PCBoxList: [],
      PLCBoxList: [],
      videoBoxList: [],

      // 是否显示列表
      isPC: false,
      isPLC: false,
      isCarNo: false,

      displayText: "",

      num: 0,

      // 获取输入框第一次的值
      initPCVal: "",
      initPLCVal: "",
      initVideoVal: "",

    };
  },

  created() {
    let that = this;
    let date = new Date();
    let year = date.getFullYear(); // 年
    let month = date.getMonth() + 1; // 月
    let day = date.getDate(); // 日
    // 当天时间
    that.time = year + "-" + month + "-" + day;
    that.time2 = year + "-" + month + "-" + day;

  },
  methods: {
    init() {
      let that = this;
      let timestamp = Math.floor(Date.now() / 1000);
      let params = {
        '查询关键字': that.formInline.goodName,
        '包含作废': that.formInline.cancel,
        "adUser": that.$store.state.adminLoginName69,
        'timeStamp': timestamp,
      };
      customerList(params).then((res) => {
        // 换行替换空格
        // console.log(/\n/.test(res.data))
        // let str = res.data;
        // str = str.replace(/[\r\n]/g, "");
        // console.log(JSON.parse(str));

        if (res.data.code == 200) {
          that.eveyData = res.data.data;
        } else if (res.data.code == 408) {
          that.$router.push({
            path: "/admin666",
          });
          that.$message({
            type: "error",
            message: res.data.message,
          });
        } else {
          that.$message({
            type: "error",
            message: res.data.message,
          });
        }
      });
    },

    // 重置
    reset() {
      this.formInline.goodName = '';
      this.formInline.cancel = '0';
      this.init();
    },

    // 编辑
    // handleEdit(index, row) {
    //   this.$refs.addPopDialog.isDialog(true, row, "编辑");
    // },

    // 新增
    add() {
      this.$refs.addCustomersDialog.isDialog(true, "新增用户");
    },

    // 编辑
    editItem(row) {
      this.$refs.editCustomersDialog.isDialog(true, row, "编辑用户");
    },

    //停用
    handleStop(row) {
      let that = this;
      let timestamp = Math.floor(Date.now() / 1000);
      let params = {
        "timeStamp": timestamp.toString(),
        "companyID": row.企业云ID,
      }
      stop(params).then((res) => {
        if (res.data.code == 200) {
          that.init();
          that.$message({
            type: "success",
            message: res.data.message,
          });
        } else {
          that.$message({
            type: "error",
            message: res.data.message,
          });
        }
      })
    },


    // 实时输入按钮
    realTimeInput(row) {
      let date = new Date();
      let year = date.getFullYear(); // 年
      let month = date.getMonth() + 1; // 月
      let day = date.getDate(); // 日
      this.isOpen = row.司机实时输入功能 == '' ? '未开通' : '已开通';
      this.ID = row.企业云ID;
      let startTime = row.实时输入有效期.split(" ")[0].replace(/\//g, "-");
      if (startTime == '') {
        // 当天时间
        this.time = year + "-" + month + "-" + day;
      } else {
        this.time = startTime
      }

      this.bzNum = row.磅站数量;
      this.dialogVisible = true;
      let arr = [];
      for (let i = 0; i < 3; i++) {
        arr.push({
          id: i + 1,
          value: i + 1,
          label: i + 1,
        })
      }
      this.bzList = arr;

    },

    // 保存实时输入
    saveSS() {
      let that = this;
      let timestamp = Math.floor(Date.now() / 1000);
      let params = {
        "expDate": that.time,
        "timeStamp": timestamp.toString(),
        "companyID": that.ID,
        "磅站数量": that.bzNum,
      }
      start(params).then((res) => {
        if (res.data.code == 200) {
          that.init();
          that.dialogVisible = false;
          that.$message({
            type: "success",
            message: res.data.message,
          });
        } else {
          that.$message({
            type: "error",
            message: res.data.message,
          });
        }
      })
    },

    // 保存云盒
    saveSCB() {
      let that = this;
      let timestamp = Math.floor(Date.now() / 1000);
      let params = {
        "expDate": that.time2,
        "timeStamp": timestamp.toString(),
        "companyID": that.ID2,
        "磅站数量": that.bzNum2,
        "云盒类型": that.boxType,
        "云盒车号识别仪": that.boxCar,
      }
      SCloudBox(params).then((res) => {
        if (res.data.code == 200) {
          that.init();
          that.dialogVisible2 = false;
          that.$message({
            type: "success",
            message: res.data.message,
          });
        } else {
          that.$message({
            type: "error",
            message: res.data.message,
          });
        }
      })
    },

    // 开启云盒弹框                                  
    startCloudBox(row) {
      let date = new Date();
      let year = date.getFullYear(); // 年
      let month = date.getMonth() + 1; // 月
      let day = date.getDate(); // 日
      this.isOpen2 = row.云盒类型 == 1 ? '已开通' : '未开通';
      this.ID2 = row.企业云ID;
      // 有效期
      let startTime;
      if (row.云盒有效期 == '-' || row.云盒有效期 == '') {
        startTime = '';
      } else {
        startTime = row.云盒有效期.split(" ")[0].replace(/\//g, "-");
      }
      if (startTime == '') {
        // 当天时间
        this.time2 = year + "-" + month + "-" + day;
      } else {
        this.time2 = startTime
      }
      // 云盒类型
      this.boxType = Number(row.云盒类型) == 0 || Number(row.云盒类型) == 1 ? 1 : 2;
      // 云盒车号识别仪
      this.boxCar = Number(row.云盒车号识别仪);
      // 磅站数量
      this.bzNum2 = row.磅站数量;

      this.dialogVisible2 = true;
      let arr = [];
      for (let i = 0; i < 3; i++) {
        arr.push({
          id: i + 1,
          value: i + 1,
          label: i + 1,
        })
      }
      this.bzList = arr;

    },


    // 点击设备管理
    equipmentManagement(row) {
      let that = this;
      that.dialogVisible3 = true;
      that.itemRow = row;
      if (row.云盒类型 == 1) {
        that.initPCList(row);
        that.isPC = true;
        that.isPLC = false;
        that.displayText = 'PC列表';
      } else {
        that.initPLCList(row);
        that.isPC = false;
        that.isPLC = true;
        that.displayText = 'PLC列表';
      }

      if (row.云盒车号识别仪 == 1) {
        that.initvideoBoxList(row)
        that.isCarNo = true;
      } else {
        that.isCarNo = false;

      }
    },


    // 初始化pc云盒
    initPCList(row) {
      let that = this;
      let timestamp = Math.floor(Date.now() / 1000);
      let params = {
        "timeStamp": timestamp.toString(),
        "companyID": row.企业云ID,
      }
      PCList(params).then((res) => {
        if (res.data.code == 200) {
          if (res.data.result.dataCount > 0) {
            let count = row.磅站数量;
            that.PCBoxList = res.data.data.slice(0, count);
          }

        } else {
          that.$message({
            type: "error",
            message: res.data.message,
          });
        }
      })
    },


    // 初始化plc云盒
    initPLCList(row) {
      let that = this;
      let timestamp = Math.floor(Date.now() / 1000);
      let params = {
        "timeStamp": timestamp.toString(),
        "companyID": row.企业云ID,
      }
      PLCList(params).then((res) => {
        if (res.data.code == 200) {
          if (res.data.result.dataCount > 0) {
            let count = row.磅站数量;
            that.PLCBoxList = res.data.data.slice(0, count)
          }
        } else {
          that.$message({
            type: "error",
            message: res.data.message,
          });
        }
      })
    },

    // 初始化车号识别仪列表
    initvideoBoxList(row) {
      let that = this;
      let timestamp = Math.floor(Date.now() / 1000);
      let params = {
        "timeStamp": timestamp.toString(),
        "companyID": row.企业云ID,
      }
      getVideoBoxList(params).then((res) => {
        if (res.data.code == 200) {
          that.videoBoxList = res.data.data;
        } else {
          that.$message({
            type: "error",
            message: res.data.message,
          });
        }
      })
    },

    // pc输入框失焦事件
    handleBlurPC(index) {
      let val = this.PCBoxList[index].设备ID;
      this.lastPCVal = val
    },

    // pc改变输入框保存
    PCSave(index) {
      let that = this;
      that.num++;
      if (that.num == 1) {
        that.initPCVal = that.PCBoxList[index].设备ID;
      }

      let timestamp = Math.floor(Date.now() / 1000);
      let params = {
        "timeStamp": timestamp.toString(),
        "companyID": that.itemRow.企业云ID,
        "locationID": index,
        "旧设备ID": that.initPCVal,
        "设备ID": that.PCBoxList[index].设备ID,

      }
      PCUpdate(params).then((res) => {
        if (res.data.code == 200) {
          that.num = 0;
          that.$message({
            type: "success",
            message: res.data.message,
          });
        } else {
          that.$message({
            type: "error",
            message: res.data.message,
          });
        }
      })
    },

    // plc改变输入框保存
    PLCSave(index) {
      let that = this;
      that.num++;
      if (that.num == 1) {
        that.initPLCVal = that.PLCBoxList[index].设备ID;
      }

      let timestamp = Math.floor(Date.now() / 1000);
      let params = {
        "timeStamp": timestamp.toString(),
        "companyID": that.itemRow.企业云ID,
        "locationID": index,
        "旧设备ID": that.initPLCVal,
        "设备ID": that.PLCBoxList[index].设备ID,

      }
      PLCUpdate(params).then((res) => {
        if (res.data.code == 200) {
          that.num = 0;
          that.$message({
            type: "success",
            message: res.data.message,
          });
        } else {
          that.$message({
            type: "error",
            message: res.data.message,
          });
        }
      })


    },

    saveSSS() { },


    // 关闭云盒管理
    StopCloudBox(row) {
      let that = this;
      let timestamp = Math.floor(Date.now() / 1000);
      let params = {
        "timeStamp": timestamp.toString(),
        "companyID": row.企业云ID,
        "expDate": row.云盒有效期,
      }
      ECloudBox(params).then((res) => {
        if (res.data.code == 200) {
          that.init();
          that.$message({
            type: "success",
            message: res.data.message,
          });
        } else {
          that.$message({
            type: "error",
            message: res.data.message,
          });
        }
      })
    },

    // 小程序开通
    openPush(row){
      
    },


    // 关闭弹框
    handleClose() {
      this.dialogVisible = false;
    },

    handleClose2() {
      this.dialogVisible2 = false;
    },

    handleClose3() {
      this.dialogVisible3 = false;
    },

  },
};
</script>
<style lang="less" scoped>
/deep/ .el-table__fixed-right {
  height: 100% !important;
}


/deep/ .el-dialog__footer {
  padding: 10px;
}

.boxLeft {
  width: 48%;
  float: left;
  overflow: hidden;

  h2 {
    margin: 5px 0;
    text-align: center;
  }

  .hadAddBtn {
    width: 100%;
    overflow: hidden;
    height: 40px;
  }
}

.boxRight {
  width: 48%;
  float: left;
  overflow: hidden;

  h2 {
    margin: 5px 0;
    text-align: center;
  }

  .hadAddBtn {
    width: 100%;
    overflow: hidden;
    height: 40px;
  }

}
</style>


// WEBPACK FOOTER //
// src/views/admin69/cloudCustomers.vue